import { useTranslation } from "@i18n";
import ButtonComponent from "../../cubeComponent/form/ButtonComponent";
import { getImageUrl } from "@Utils";

interface SubscriptionWarningProps {
  message?: React.ReactNode;
  description?: React.ReactNode;
  showUpgradeButton?: boolean;
  showFooterMessage?: boolean;
}

function SubscriptionWarning({
  message,
  description,
  showUpgradeButton,
  showFooterMessage,
}: Readonly<SubscriptionWarningProps>) {
  const { t } = useTranslation();
  return (
    <>
      <div className="flex w-full flex-col items-center justify-around">
        <img className="" src={`${getImageUrl()}/logoAndText.png`} />
        <div className="flex w-full flex-col items-center gap-16">
          <div className="flex flex-col items-center gap-14">
            <img className="w-fit me-[-9.375rem]" src={`${getImageUrl()}/subscriptionWarning.svg`} />
            <div className="flex flex-col gap-3">
              <span className="text-4xl font-bold">{message}</span>
              <span className="text-2xl font-bold">{description}</span>
            </div>
          </div>
          {showUpgradeButton && (
            <div className="flex">
              <ButtonComponent>{t("Upgrade")}</ButtonComponent>
            </div>
          )}
        </div>
        {showFooterMessage && (
          <div className="text-center">
            {t(
              "Need support with increasing/decreasing your seats or have any questions related to pricing or billing? Raise a support ticket here.",
            )}
          </div>
        )}
      </div>
    </>
  );
}

export default SubscriptionWarning;
